export default __webpack_public_path__ + "static/media/notice.ed209ead.png";